import React from 'react';
import { Icon } from '@iconify/react';
import { AppBadge } from '../ui';
import cx from '../ui/cx';
import '../../styles/users-admin.scss';

const STATUS_OPTIONS = [
  { value: true, label: 'Compte actif', variant: 'success', icon: 'mdi:check' },
  { value: false, label: 'Compte inactif', variant: 'danger', icon: 'mdi:close' },
];

const UserActiveToggle = ({ active = true, onChange, disabled = false }) => (
  <div className="user-tag-picker" role="radiogroup" aria-label="Statut du compte">
    {STATUS_OPTIONS.map((option) => {
      const isSelected = active === option.value;
      return (
        <AppBadge
          key={String(option.value)}
          as="button"
          type="button"
          pill
          variant={isSelected ? option.variant : 'neutral'}
          className={cx('user-tag', isSelected && 'user-tag--selected')}
          role="radio"
          aria-checked={isSelected}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {isSelected ? <Icon icon={option.icon} width={14} aria-hidden /> : null}
          {option.label}
        </AppBadge>
      );
    })}
  </div>
);

export default UserActiveToggle;
